export const iconFontAwesomeUsersPeopleChildReaching = (
	<i className="fa-solid fa-child-reaching"></i>
);
